import { call, put, takeLatest, all } from 'redux-saga/effects';
import { showToast } from 'app/store/actions/fuse';
import * as Actions from '../../actions';
import userService from '../../../services/userService';
import history from '@history';

function* fetchUser(action) {
	const { userId } = action.payload;
	try {
		let response = yield call(() => userService.fetchUserInfo(userId));
		yield put(Actions.fetchUserSuccess(response.data));
	} catch (error) {
		yield put(showToast.error('Unable to retrieve User' + error));
		yield put(Actions.fetchUserFailure());
	}
}

function* fetchUserRoles(action) {
	try {
		let response = yield call(() => userService.fetchUserRoles(action.payload));
		yield put(Actions.fetchUserRolesSuccess(response.data));
	} catch (error) {
		yield put(showToast.error('Unable to retrieve UserRoles' + error));
		yield put(Actions.fetchUserRolesFailure());
	}
}

function* updateUser(action) {
	try {
		const response = yield call(() => userService.updateUser(action.payload));
		yield put(Actions.updateUserSuccess(response.data));
		yield put(showToast.success('User updated'));
	} catch (error) {
		yield put(showToast.error('Unable to save User' + error));
		yield put(Actions.updateUserFailure());
	}
}

function* createUser(action) {
	try {
		const response = yield call(() => userService.createUser(action.payload));
		yield put(Actions.createUserSuccess(response.data));
		history.push(`/users`);
		yield put(showToast.success('User Saved'));
	} catch (error) {
		yield put(showToast.error('Unable to save User' + error));
		yield put(Actions.createUserFailure());
	}
}

function* createUserRole(action) {
	try {
		const response = yield call(() => userService.createUserRole(action.payload));
		yield put(Actions.createUserRoleSuccess(response.data));
		yield put(
			Actions.fetchUserRoles({ userId: action.payload.userId, applicationId: action.payload.applicationId })
		);
		yield put(showToast.success('User Role Saved'));
	} catch (error) {
		yield put(showToast.error('Unable to save User Role' + error));
		yield put(Actions.createUserRoleFailure());
	}
}

function* removeUserRole(action) {
	try {
		const response = yield call(() => userService.removeUserRole(action.payload));
		yield put(Actions.removeUserRoleSuccess(response.data));
		yield put(
			Actions.fetchUserRoles({ userId: action.payload.userId, applicationId: action.payload.applicationId })
		);
		yield put(showToast.success('User Role Removed'));
	} catch (error) {
		yield put(showToast.error('Unable to remove User Role' + error));
		yield put(Actions.removeUserRoleFailure());
	}
}

function* changePassword(action) {
	const { user } = action.payload;
	try {
		const response = yield call(() => userService.changeUserPassword(user));
		yield put(Actions.changeUserPasswordSuccess(response.data));
		yield put(showToast.success('Password updated'));
	} catch (error) {
		yield put(showToast.error('Unable to change password' + error));
		yield put(Actions.changeUserPasswordFailure());
	}
}

function* deleteUser(action) {
	try {
		const response = yield call(() => userService.deleteUser(action.payload));
		yield put(Actions.deleteUserSuccess(response.data));
		history.push('/users');
		yield put(showToast.success('User deleted'));
	} catch (error) {
		yield put(showToast.error('Unable to delete user ' + error));
		yield put(Actions.deleteUserFailure());
	}
}

function* fetchUserOverrides(action) {
	try {
		const response = yield call(() => userService.fetchUserOverrides(action.payload));
		yield put(Actions.fetchUserOverridesSuccess(response.data));
	} catch (error) {
		yield put(showToast.error('Unable to retrieve user overrides ' + error));
		yield put(Actions.fetchUserOverridesFailure());
	}
}

function* createUserOverride(action) {
	try {
		const response = yield call(() => userService.createUserOverride(action.payload.override));
		yield put(Actions.createUserOverrideSuccess(response.data));
		yield put(
			Actions.fetchUserOverrides({
				userId: action.payload.override.userId,
				applicationId: action.payload.applicationId
			})
		);
		yield put(showToast.success('Permissions updated'));
	} catch (error) {
		yield put(showToast.error('Unable to update permissions ' + error));
		yield put(Actions.createUserOverrideFailure());
	}
}

function* deleteUserOverride(action) {
	try {
		const response = yield call(() => userService.deleteUserOverride(action.payload));
		yield put(Actions.deleteUserOverrideSuccess(response.data));
		yield put(
			Actions.fetchUserOverrides({
				userId: action.payload.userId,
				applicationId: action.payload.applicationId
			})
		);
		yield put(showToast.success('Permissions updated'));
	} catch (error) {
		yield put(showToast.error('Unable to update permissions ' + error));
		yield put(Actions.deleteUserOverrideFailure());
	}
}

function* fetchUserPolicies(action) {
	try {
		let response = yield call(() => userService.fetchUserPolicies(action.payload));
		yield put(Actions.fetchUserPoliciesSuccess(response.data));
	} catch (error) {
		yield put(showToast.error('Unable to retrieve User Policies' + error));
		yield put(Actions.fetchUserPoliciesFailure());
	}
}

function* watchUser() {
	yield all([
		takeLatest(Actions.fetchUser, fetchUser),
		takeLatest(Actions.updateUser, updateUser),
		takeLatest(Actions.createUser, createUser),
		takeLatest(Actions.changeUserPassword, changePassword),
		takeLatest(Actions.deleteUser, deleteUser),
		takeLatest(Actions.fetchUserOverrides, fetchUserOverrides),
		takeLatest(Actions.createUserOverride, createUserOverride),
		takeLatest(Actions.deleteUserOverride, deleteUserOverride),
		takeLatest(Actions.fetchUserPolicies, fetchUserPolicies),
		takeLatest(Actions.fetchUserRoles, fetchUserRoles),
		takeLatest(Actions.createUserRole, createUserRole),
		takeLatest(Actions.removeUserRole, removeUserRole)
	]);
}

export default watchUser;
